// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./20260919140000-create-project-replica.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/project-replica-migrations/20260919140000-create-project-replica.js"); } },
  "./20260924163000-add-task-automation-presentation.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/project-replica-migrations/20260924163000-add-task-automation-presentation.js"); } },
  "./20260924190000-add-task-board-placement-presentation.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/project-replica-migrations/20260924190000-add-task-board-placement-presentation.js"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;